export function pagination() {
    const pagintaionElems = document.querySelectorAll('.pagintation__elem');
    pagintaionElems.forEach(elem=>{
        const paginationAttr = elem.getAttribute('data-attr');
        const paginationPage = elem.getAttribute('data-page');
        elem.addEventListener('click',()=>{
            
        });
    });
}